import React from 'react';
import styled from 'styled-components';
import {SWT} from './fonts/SWT';
import {Colors} from '../Abstracts/Colors';

const SCFinishArticle = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  padding: 0.5rem;
  background-color: ${Colors.lightBlue};
`;

export function FinishArticle() {
  return (
    <SCFinishArticle>
      <p>
        <strong>
          E Allah <SWT /> Sabe Melhor.
        </strong>
      </p>
      <p className="arabicFont">الله أعلم</p>
    </SCFinishArticle>
  );
}
